import { ValidationRegex } from '../data/Regex';

export default function getOfficeLivePreviewUrl(url: string) {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${
    ValidationRegex.absolutePath.test(url) ? document.location.origin : ''
  }${url}`;
}
